import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbMoreDots: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <rect x='1' y='9' width='6' height='6' />
          <rect x='9' y='9' width='6' height='6' />
          <rect x='17' y='9' width='6' height='6' />
        </g>
      </svg>
    </>
  );
};
